
import AlertsStore from "../Alerts/Store";

// TODO: Make this work on MMSI/etc. perhaps too.
// TODO: Review placement of filter truth function for finding vessels with imo in list (currently in AlertList)
const FilterHelper = {};

// This can be passed directly to array.filter to resolve only unique items.
FilterHelper.unique = (value, index, selff) => {
	return selff.indexOf(value) === index;
};

FilterHelper.filterVesselsByAlertListString = (vessel, userSpecifiedImos) => {
	const vesselDataObjectImo = vessel.imo;
	const vesselObjectImoIndex = userSpecifiedImos.findIndex(imo => imo === vesselDataObjectImo);
	return vesselObjectImoIndex >= 0;
};

FilterHelper.filterAlertRowByVisibleAlertTypes = row => {
	return AlertsStore.helpers.isAlertTypeVisible(row.alertType);
};

FilterHelper.filterTableDataByIMOList = (tableData, imoList = []) => {
	if (imoList.length === 0) {
		return tableData;
	}
	return tableData.filter((row) => {
		for (let i = 0; i < imoList.length; i++) {
			if (("" + row.imo).indexOf(imoList[i]) >= 0) {
				return true;
			}
		}
		return false;
	});
};
/**
 * @param {*} values -- ensure all lower case values.
 */
FilterHelper.filterTableDataByPropertyList = (tableData, values = [], properties = []) => {
	if (values.length === 0) {
		return tableData;
	}

	return tableData.filter((row) => {
		for (let j = 0; j < properties.length; j++) {
			for (let i = 0; i < values.length; i++) {
				const prop = ("" + row[properties[j]]).toLowerCase();
				if (prop.indexOf(values[i]) >= 0) {
					return true;
				}
			}
		}
		return false;
	});
};
export default FilterHelper;
